module.exports = __webpack_public_path__ + "img/response2019_e.ae8b81a6.jpg";